import React from 'react';
import { Link } from 'react-router-dom';

interface BlogMeta {
  slug: string;
  title: string;
  author: string;
  date: string;
}

interface BlogIndexTileProps {
  post: BlogMeta;
}

// Helper to fetch preview text from the markdown file
const useBlogPreview = (slug: string) => {
  const [preview, setPreview] = React.useState('');
  React.useEffect(() => {
    fetch(`/blog/${slug}.md`)
      .then(res => res.text())
      .then(text => {
        // Remove frontmatter
        const match = text.match(/^---[\s\S]*?---\s*/);
        const body = match ? text.slice(match[0].length) : text;
        // Get first 5 lines (excluding empty lines and markdown headers)
        const lines = body.split('\n').filter(l => l.trim() && !l.trim().startsWith('#'));
        let previewText = lines.slice(0, 5).join(' ');
        // Limit to 300 chars
        if (previewText.length > 300) previewText = previewText.slice(0, 297) + '...';
        setPreview(previewText);
      });
  }, [slug]);
  return preview;
};

export const BlogIndexTile: React.FC<BlogIndexTileProps> = ({ post }) => {
  const preview = useBlogPreview(post.slug);
  const dateStr = (() => {
    const d = new Date(post.date);
    return isNaN(d.getTime()) ? post.date : d.toLocaleDateString(undefined, { year: 'numeric', month: 'long', day: 'numeric' });
  })();
  return (
    <div className="bg-black rounded-2xl px-8 py-8 flex flex-col items-start text-left w-full max-w-3xl mx-auto border border-white/20">
      <div className="text-white text-base mb-2">{dateStr} <span className="mx-2">·</span> By <span className="font-semibold text-white">{post.author}</span></div>
      <Link to={`/${post.slug}`} className="text-2xl sm:text-3xl font-bold text-white mb-4 leading-tight font-sans hover:text-primary transition-colors">
        {post.title}
      </Link>
      <div className="text-white text-lg font-sans mb-6 line-clamp-5" style={{ display: '-webkit-box', WebkitLineClamp: 5, WebkitBoxOrient: 'vertical', overflow: 'hidden', textOverflow: 'ellipsis' }}>{preview}</div>
      <Link to={`/${post.slug}`} className="mt-auto inline-block px-6 py-2 rounded-full border border-primary text-primary hover:bg-primary/10 transition-colors text-base font-medium">
        Read more
      </Link>
    </div>
  );
};
